import { createContext } from 'react'
import { LayoutContextData } from './LayoutContext.types'

export const LayoutContext = createContext<LayoutContextData>({
    mobile: false,
    drawer: {
        open: false,
        width: 0,
    },
    user: {
        blocked: false,
    },
    openDrawer: (open: boolean, write: boolean) => {},
    toggleDrawer: () => {},
    closeDrawer: () => {},
    blockUser: () => {},
})
